import React from 'react';
import { howItWorksData } from '@/data/mock';
import { MousePointerClick, ClipboardList, BarChart3, Upload } from 'lucide-react';

const iconMap = {
  MousePointerClick,
  ClipboardList,
  BarChart3,
  Upload,
};

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="relative py-24 bg-slate-950">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-500/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-cyan-500/10 text-cyan-400 text-sm font-medium rounded-full mb-4">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Four simple steps to better hires
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Get from job posting to qualified shortlist in record time
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {howItWorksData.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div key={index} className="relative">
                {/* Connector line */}
                {index < howItWorksData.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-full w-full h-px bg-gradient-to-r from-cyan-500/50 to-transparent z-0" />
                )}
                
                <div className="relative z-10">
                  {/* Step number */}
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-500 to-indigo-500 flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/20">
                    <span className="text-white text-2xl font-bold">{item.step}</span>
                  </div>
                  
                  <div className="flex items-center gap-2 mb-3">
                    <Icon size={18} className="text-cyan-400" />
                    <h3 className="text-lg font-semibold text-white">{item.title}</h3>
                  </div>
                  <p className="text-slate-400 text-sm">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
